// export const FIRST_AMERICAN = "1";
// export const LAWYERS_TITLE = "2";
//
// export default Object.freeze({
//   [FIRST_AMERICAN]: "First American",
//   [LAWYERS_TITLE]: "Lawyers Title"
// });

export default Object.freeze(["First American", "Lawyers Title"]);
